import { useMutation } from "@apollo/client";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";
import { deleteScheduledReportsMutattion } from "pages/Reports/queries";
import {ReportsContext} from "pages/Reports/Reports.context";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { displayError } from "utils/displayNotification";

interface IProps {
  isDeleteReportModalOpened: boolean,
  setIsDeleteReportModalOpened: Function,
  fetchReportss: Function
}

const DeleteReportForm = ({ isDeleteReportModalOpened, setIsDeleteReportModalOpened, fetchReportss }: IProps) => {

  //#region hooks
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const { selectedReport } = useContext(ReportsContext);
  //#endregion

  //#region API CALLS
  const [deleteReports] = useMutation(deleteScheduledReportsMutattion, {
    onCompleted: () => {
      toast.info(`Report deleted.`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setButtonDisabled(false);
    },
    onError: (e) => {
      displayError(e.message);
      setTimeout(() => {
        setButtonDisabled(false);
      }, 1500);
    }
  });
  //#endregion

  const handleIsDeleteReportsModalOpened = (isOpened: boolean) => {
    setIsDeleteReportModalOpened(isOpened);
  };

  const handleDeleteReports = async () => {
    setButtonDisabled(true);
    await deleteReports({ variables: { id: selectedReport.id } });
    fetchReportss();
  };

  return (
    <Modal
      isOpened={isDeleteReportModalOpened}
      className="delete-user"
      title="Delete Report"
      setIsOpenedCallback={handleIsDeleteReportsModalOpened}
    >
      <p>
        <strong>Are you sure you want to delete this report?</strong>
      </p>
      <div className="modal-buttons-container">
        <Button
          className="button--bordered button--error"
          type="button"
          content="No, keep it"
          onClick={() => setIsDeleteReportModalOpened(false)}
        ></Button>
        <Button
          className="button--error"
          type="button"
          content="Yes, delete it"
          disabled={buttonDisabled}
          onClick={() => {
            try {
              handleDeleteReports();
            } catch (e) {
              toast.error("You cannot delete your own account!")
            }
            setIsDeleteReportModalOpened(false);
          }}
        ></Button>
      </div>
    </Modal>
  );
};

export default DeleteReportForm;